export default "__VITE_ASSET__BE$o277q__"